/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import overlayMixin from "../mixins/overlay-mixin";
import requester from "modules/requester";

export default baustein.register("saved-search-edit-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        // overlay-mixin options
        overlaySize: "medium",
        noContentPadding: false,
        queryParams: {},
        path: "/create-new-search/",

        savedLystFilterId: null
    },

    onOverlayCloseIntent() {
        this.close();
    },

    getOverlayContent() {
        this.options.queryParams["edit"] = this.options.savedLystFilterId;
        this.options.queryParams["overlay"] = 1;
        return requester(this.options.path, {
            headers: {
                Accept: "text/html"
            },
            query: this.options.queryParams
        }).then(resp => {
            return requester.toText(resp);
        });
    }
});

